import { type EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { AuthService } from '@core/auth/auth.service';
import { lastValueFrom } from 'rxjs';

/**
 * Registers optional startup hooks for session restoration.
 * Extend the initializer when Axelor session probing is implemented.
 */
export function provideCoreAuth(): EnvironmentProviders[] {
  return [
    provideAppInitializer(() => {
      const auth = inject(AuthService);
      return lastValueFrom(auth.restoreSession());
    }),
  ];
}
